// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4348":"6862281f","6742":"0c6c197c"}[chunkId] + ".chunk.css";
};